import axiosInstance from "../common/axios/axsiosInstance";

/**
 * List issues for the current org; optional filter by user_urn id (DB id).
 * @param {{ urnId?: number, skip?: number, limit?: number }} params
 */
export async function listIssues(params = {}) {
  const { urnId, skip = 0, limit = 200 } = params;
  const q = new URLSearchParams();
  q.set("skip", String(skip));
  q.set("limit", String(limit));
  if (urnId != null) q.set("urn_id", String(urnId));
  const { data } = await axiosInstance.get(`user/issues?${q.toString()}`);
  return data;
}

export async function getIssue(issueId) {
  const { data } = await axiosInstance.get(`user/issues/${issueId}`);
  return data;
}

export async function createIssue(body) {
  const { data } = await axiosInstance.post("user/issues", body);
  return data;
}

export async function updateIssue(issueId, body) {
  const { data } = await axiosInstance.patch(`user/issues/${issueId}`, body);
  return data;
}

export async function deleteIssue(issueId) {
  await axiosInstance.delete(`user/issues/${issueId}`);
}

export async function listComments(issueId) {
  const { data } = await axiosInstance.get(`user/issues/${issueId}/comments`);
  return data;
}

export async function createComment(issueId, body) {
  const { data } = await axiosInstance.post(
    `user/issues/${issueId}/comments`,
    body,
  );
  return data;
}

export async function updateComment(issueId, commentId, body) {
  const { data } = await axiosInstance.patch(
    `user/issues/${issueId}/comments/${commentId}`,
    body,
  );
  return data;
}

export async function deleteComment(issueId, commentId) {
  await axiosInstance.delete(`user/issues/${issueId}/comments/${commentId}`);
}

export async function listAttachments(issueId) {
  const { data } = await axiosInstance.get(
    `user/issues/${issueId}/attachments`,
  );
  return data;
}

export async function uploadAttachment(issueId, file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axiosInstance.post(
    `user/issues/${issueId}/attachments`,
    form,
  );
  return data;
}

export async function deleteAttachment(issueId, attachmentId) {
  await axiosInstance.delete(
    `user/issues/${issueId}/attachments/${attachmentId}`,
  );
}

/** @returns {Promise<import('axios').AxiosResponse<Blob>>} */
export async function downloadAttachmentBlob(issueId, attachmentId) {
  return axiosInstance.get(
    `user/issues/${issueId}/attachments/${attachmentId}/download`,
    { responseType: "blob" },
  );
}

export async function listAssignees(issueId) {
  const { data } = await axiosInstance.get(`user/issues/${issueId}/assignees`);
  return data;
}

export async function replaceAssignees(issueId, userIds) {
  const { data } = await axiosInstance.put(`user/issues/${issueId}/assignees`, {
    user_ids: userIds,
  });
  return data;
}

export async function listAudit(issueId, params = {}) {
  const { skip = 0, limit = 100 } = params;
  const q = new URLSearchParams();
  q.set("skip", String(skip));
  q.set("limit", String(limit));
  const { data } = await axiosInstance.get(
    `user/issues/${issueId}/audit?${q.toString()}`,
  );
  return data;
}

export async function fetchMyUrns() {
  const { data } = await axiosInstance.get("user/my-urns");
  return data;
}

export async function fetchUserProfile() {
  const { data } = await axiosInstance.get("user/profile");

  return data;
}

/**
 * Resolve DB user_urn id for a Forge viewer document URN string.
 * @param {string|null|undefined} documentUrn
 * @returns {Promise<number|null>}
 */
export async function resolveUserUrnId(documentUrn) {
  if (!documentUrn) return null;
  const rows = await fetchMyUrns();
  const row = rows.find((r) => r.urn === documentUrn);
  return row?.id ?? null;
}
